import  { useEffect, useState } from 'react'
import ParticipantList from "./participantList";
import ParticipantSelect from "./participantSelect"
import ParticipantDetails from './participantDetails';
//import ParticipantUpdateModal from './participantUpdateModal';
import useListParticipant from '../services/participantService';
import useWave from "../services/waveService";
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import {Typography} from '@mui/material';
import { CircularProgress, Backdrop } from '@mui/material';

const Participant = () => {
    const { participantsData, isLoadingParticipants, participantsServerError, queryparticipants, patchParticipant, registerActor, participantsMessage, resetParticipant, teamFromList } = useListParticipant();
    const { wavesData, fetchWaves }  = useWave();
    const [showAlert, setShowAlert] = useState(true)
    const [itemsFound, setItemsFound] = useState(false)

    useEffect(() => {
        setShowAlert(true)
    }, [isLoadingParticipants, setShowAlert])

    useEffect(() => {
        const hasData = participantsData && participantsData.length > 0
        setItemsFound(hasData)
    }, [isLoadingParticipants, participantsData, setItemsFound])

    useEffect(() => {
        fetchWaves();
    }, []);

    return (
        <Box sx={{ paddingTop: '10px'}}>
            <ParticipantSelect itemsFound={itemsFound} isLoading={isLoadingParticipants} queryParticipants={queryparticipants} teamFromList={teamFromList}/>
            <ParticipantList participants={participantsData} registerActor={registerActor} patchParticipant={patchParticipant} resetParticipant={resetParticipant} wavesData={wavesData}/>
            {/*participant &&<ParticipantDetails participant={participant} close={closeDialog} resetParticipant={resetParticipant}/>*/}
            {/*{participant &&<ParticipantUpdateModal participant={participant} close={closeDialog} resetParticipant={resetParticipant} patchParticipant={patchParticipant}/>*/}
            {participantsServerError && showAlert && <Alert onClose={() => {setShowAlert(false)}} severity="error">{participantsServerError}</Alert>}
            {participantsMessage && showAlert && <Alert onClose={() => {setShowAlert(false)}} severity="success">{participantsMessage}</Alert>}
            <Backdrop 
                sx={{ color: '#fff', zIndex: 999999 }}
                open={isLoadingParticipants}
            ><CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}

export default Participant
